import React, { useRef } from 'react';
import * as Lottie from '@lottiefiles/react-lottie-player';

type lottieFileName = 'dotPulseBlue' | 'dotPulseGreen' | 'sparklesWithGradient';

type LottieAnimationsLoaderProps = {
  fileName: lottieFileName;
  height?: React.CSSProperties['height'];
  width?: React.CSSProperties['width'];
};

const DEFAULT_SIZE = 24;

export const LottieAnimationsLoader: React.FC<LottieAnimationsLoaderProps> = ({ fileName, height, width }) => {
  const animationRef = useRef<Lottie.Player>(null);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: width || DEFAULT_SIZE,
        height: height || DEFAULT_SIZE,
      }}
    >
      <Lottie.Player
        ref={animationRef}
        src={`assets/animations/${fileName}.json`}
        autoplay={true}
        loop={true}
        style={{ display: 'flex' }}
      />
    </div>
  );
};

export default LottieAnimationsLoader;
